<template>
  <!-- Applica filtri se premuto INVIO. -->
  <v-card class="d-flex" color="#F0F0F0" @keyup.enter="applicaFiltri">
    <!-- Caricamento filtri dinamico (che abbiano visibilità = 1). -->
    <span
      v-for="(item, index) in lista_filtri_dettaglio"
      :key="item.id_ricerca_dettaglio"
    >
      <template v-if="item.visible == 1">
        <!-- Tipo TEXT_FIELD. -->
        <v-text-field
          v-if="item.tipo_oggetto == TipoOggetto.TEXT_FIELD"
          class="ml-3 mr-3"
          :label="item.des_ricerca_dettaglio"
          v-model="item.valore"
        />

        <!-- Tipo DATA_QUERY / DATA_PICKER. -->
        <v-text-field
          v-if="
            item.tipo_oggetto == TipoOggetto.DATA_PICKER ||
            item.tipo_oggetto == TipoOggetto.DATA_QUERY
          "
          type="date"
          class="ml-3 mr-3"
          :label="item.des_ricerca_dettaglio"
          v-model="item.valore"
        />

        <!-- Tipo SELECT / MULTI_SELECT. -->
        <v-autocomplete
          v-if="
            item.tipo_oggetto == TipoOggetto.MULTI_SELECT ||
            item.tipo_oggetto == TipoOggetto.SELECT
          "
          :multiple="item.tipo_oggetto == TipoOggetto.MULTI_SELECT"
          class="ml-3 mr-3"
          item-text="text"
          item-value="value"
          :label="item.des_ricerca_dettaglio"
          :items="item.lista_query"
          :search-input.sync="input_autocomplete[index]"
          v-model="item.valore"
          @change="
            input_autocomplete[index] = '';
            aggiornaDipendenze(item);
          "
        />
      </template>
    </span>

    <!-- Pulsante applica filtro. -->
    <v-tooltip bottom v-if="lista_filtri_dettaglio.length > 0">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          class="mt-5 ml-3 mr-3"
          v-on="on"
          v-bind="attrs"
          @click="applicaFiltri"
        >
          <v-icon color="primary">mdi-magnify</v-icon>
        </v-btn>
      </template>
      <span>Filtra</span>
    </v-tooltip>

    <v-spacer />

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <SnackbarQV ref="SnackbarQV" />

    <!-- Set di filtri. -->
    <!-- <v-autocomplete
      class="ml-3 mr-3"
      style="max-width: 150px"
      label="Set di filtri"
      item-value="id_ricerca"
      item-text="des_ricerca"
      :items="lista_set_di_filtri"
      v-model="id_ricerca_sel"
      @change="aggiornaVisualizzazioneFiltri(computeIsDefault);
               applicaFiltri();">
        <template v-slot:item="{ item }">
          <div style="text-align: left">
            {{ item.des_ricerca }}
          </div>
        </template>
    </v-autocomplete> -->
  </v-card>
</template>

<script>
import moment from "moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

const TipoOggetto = Object.freeze({
  TEXT_FIELD: 0,
  DATA_PICKER: 1,
  DATA_QUERY: 2,
  MULTI_SELECT: 3,
  SELECT: 4,
});

export default {
  name: "InputRicerca",
  components: { SnackbarQV },
  props: {
    lista_filtri: { type: Array, default: () => [] },
    key_update: { type: Boolean, default: null },
    id_session_key: { type: String, default: null },
  },

  data() {
    return {
      // Costanti.
      TipoOggetto,

      // Variabili di supporto.
      caricamento_dati: false,
      id_ricerca_sel: null,
      ricerca_iniziale_eseguita: false,

      // Array.
      lista_set_di_filtri: new Array(),
      lista_filtri_dettaglio: new Array(),
      input_autocomplete: new Array(),
    };
  },

  methods: {
    aggiornaDipendenze(arg) {
      this.lista_filtri_dettaglio.forEach(async (d) => {
        if (
          (d.tipo_oggetto == TipoOggetto.SELECT ||
            d.tipo_oggetto == TipoOggetto.MULTI_SELECT) &&
          d.query_tabella.includes(`{${arg.id_ricerca_dettaglio_tmp}}`)
        ) {
          let query_tmp = d.query_tabella;
          query_tmp = query_tmp.replaceAll(
            `{${arg.id_ricerca_dettaglio_tmp}}`,
            `'${arg.valore}'`
          );

          /* Se la mia autocomplete originale + vuota,
           * cancello i valori della sua dipendente. */
          if (arg.valore == null || arg.valore == "") {
            d.lista_query = new Array();
            d.valore = null;
          } else if (
            !query_tmp.includes("{") &&
            d.query_tabella.includes(`{${arg.id_ricerca_dettaglio_tmp}}`)
          ) {
            /* Se invece l'input originale non è vuoto e la query dipendente
             * non ha più placeholder da sostituire, eseguo la query. */
            await this.eseguiQuery(query_tmp, d.id_ricerca_dettaglio);
          }
        }
      });
    },
    aggiornaVisualizzazioneFiltri(get_session = false) {
      // Aggiorna i filtri dettaglio.
      this.lista_filtri_dettaglio = [];

      let filtri_copy;

      let set_di_filtri_sel = this.lista_filtri.find((e) => {
        return e.id_ricerca === this.id_ricerca_sel;
      });
      if (set_di_filtri_sel) {
        set_di_filtri_sel = JSON.parse(JSON.stringify(set_di_filtri_sel));
        filtri_copy = set_di_filtri_sel.filtri_dettaglio;
      }

      if (filtri_copy) this.lista_filtri_dettaglio = [...filtri_copy];

      // Se il parametro chiede di prendere la sessione, lo fa e aggiorna i filtri.
      if (get_session) {
        let sessione_filtri = JSON.parse(this.getSessione());

        // Assegna per ogni filtro il valore salvato.
        if (sessione_filtri) {
          this.lista_filtri_dettaglio.forEach((e) => {
            let filtro_sessione = sessione_filtri.find(
              (i) => i.id_ricerca_dettaglio == e.id_ricerca_dettaglio
            );
            e.valore = filtro_sessione ? filtro_sessione.valore : e.valore;
          });
        }
      }

      // Ordine di apparizione (da sinistra a destra).
      this.lista_filtri_dettaglio.sort((a, b) => a.ordine - b.ordine);

      // Ordina i valori della multi-select dalla A alla Z.
      this.lista_filtri_dettaglio.forEach((e) => {
        if (e.lista_query)
          e.lista_query.sort((a, b) =>
            (a.text ? a.text : "").localeCompare(b.text ? b.text : "")
          );
      });

      this.convertiDataQuery();
    },

    applicaFiltri() {
      // Salva la sessione attuale.
      this.setSessione(JSON.stringify(this.lista_filtri_dettaglio));

      this.ricercaDati();

      // Triggera la funzione del componente padre per applicare i filtri.
      //this.$emit("applica_filtri", this.computeApplicaFiltri);
    },

    applicaFiltriSessione() {
      // "filtri_query" del componente padre viene aggiornato con i filtri salvati nella sessione.
      let sessione_filtri = this.getSessione();
      if (sessione_filtri) {
        this.lista_filtri_dettaglio = JSON.parse(sessione_filtri);
        //this.$emit("applica_filtri_sessione", this.computeApplicaFiltri);
      }
    },

    // Converti il valore e l'oggetto di DATA_QUERY in DATA_PICKER.
    convertiDataQuery() {
      this.lista_filtri_dettaglio.forEach((e) => {
        if (e.tipo_oggetto == TipoOggetto.DATA_QUERY) {
          e.tipo_oggetto = TipoOggetto.DATA_PICKER;
          if (e.valore) {
            var data_query = e.valore.split("/");

            if (data_query.length == 2) {
              let unita_tempo;
              switch (data_query[1]) {
                case "DAY":
                  unita_tempo = "days";
                  break;
                case "MONTH":
                case "START_MONTH":
                case "END_MONTH":
                  unita_tempo = "months";
                  break;
                case "YEAR":
                case "START_YEAR":
                case "END_YEAR":
                  unita_tempo = "years";
                  break;
              }

              e.valore = moment()
                .add(Number(data_query[0]), unita_tempo)
                .format("YYYY-MM-DD");

              switch (data_query[1]) {
                case "START_MONTH":
                  e.valore = moment(e.valore)
                    .startOf("month")
                    .format("YYYY-MM-DD");
                  break;
                case "END_MONTH":
                  e.valore = moment(e.valore)
                    .endOf("month")
                    .format("YYYY-MM-DD");
                  break;
                case "START_YEAR":
                  e.valore = moment(e.valore)
                    .startOf("year")
                    .format("YYYY-MM-DD");
                  break;
                case "END_YEAR":
                  e.valore = moment(e.valore)
                    .endOf("year")
                    .format("YYYY-MM-DD");
                  break;
              }
            }
          } else e.valore = moment().format("YYYY-MM-DD");
        }
      });
    },

    // Converti i valori della multi-select (stringa -> lista).
    convertiMultiSelectList() {
      this.lista_filtri_dettaglio.forEach((e) => {
        if (e.tipo_oggetto == TipoOggetto.MULTI_SELECT) {
          if (e.valore) {
            // Per effettuare il metodo "split()" dobbiamo assicurarci che il valore sia stringa.
            // Quando passato dalla sessione, è array. Se è un valore preimpostato in "GestioneFiltri" è stringa.
            if (typeof e.valore == "string") e.valore = e.valore.split(",");
          } else e.valore = [];
        }
      });
    },
    eseguiQuery(arg_query, arg_id) {
      /* Questa funzione viene richiamata nel mounted per
       *  valorizzare le autocomplete, ma potrebbe essere
       * innescata per input non appartenenti al set di
       * filtri attualmente visualizzato. Metto quindi una
       * guardia per eseguire le chiamate al BE solo se la
       * query è legata a un input che fa parte di quelli
       * attualmente selezionati. */
      if (
        this.lista_filtri[0].filtri_dettaglio.filter(
          (f) => f.id_ricerca_dettaglio == arg_id
        ).length == 0
      ) {
        return;
      }

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "performquery",
          query_string: arg_query,
          token: localStorage.user_token,
        },
      };

      this.caricamento_dati = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.data.result != null) {
            const item = this.lista_filtri_dettaglio.filter(
              (f) => f.id_ricerca_dettaglio == arg_id
            )[0];

            item.lista_query = res.data.result.Table;
            if (item.lista_query) {
              // Qualsiasi risultato (int, float, ecc...) dev'essere convertito in stringa.
              item.lista_query.forEach((e) => {
                e.value = e.value ? e.value.toString() : null;
              });

              // Riordina in ordine alfabetico.
              item.lista_query.sort((a, b) =>
                (a.text ? a.text : "").localeCompare(b.text ? b.text : "")
              );
            }
            return 0;
          } else {
            this.$refs.SnackbarQV.print("orange", "Nessuna query trovata.");
            return 1;
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          this.$refs.SnackbarQV.print(
            "error",
            err +
              ": ricontrollare che la query della autocomplete sia scritta correttamente."
          );
          return 1;
        });
    },
    getSessione() {
      // Ritorna l'oggetto salvato dall'ultima sessione con l'id corrispondente.
      let key = this.id_session_key
        ? "filtro_sessione_" + this.id_session_key
        : "";
      return key ? sessionStorage.getItem(key) : null;
    },

    ricercaDati() {
      // Faccio un array temporaneo.
      const filtri_tmp = JSON.parse(
        JSON.stringify(this.lista_filtri_dettaglio)
      );

      // Elimino i campi non necessari.
      filtri_tmp.forEach((f) => {
        if (f.lista_query) {
          delete f.lista_query;
        }
      });

      if (
        filtri_tmp.filter((f) => f.valore != null && f.valore != "").length == 0
      ) {
        this.$refs.SnackbarQV.print("orange", "Valorizzare almeno un filtro.");
        return;
      }

      // Preparo la request.
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdatiricerca",
          struttura_logica: this.lista_filtri[0].struttura_logica,
          query_string: this.lista_filtri[0].query,
          filtri: filtri_tmp,
          token: localStorage.user_token,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.$emit("applica_filtri", res.data.result.ricerca);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },

    setSessione(valore) {
      // Salva la sessione solo col set di filtri "Default" e solo se dal padre è stato passato l'id_sessione.
      if (this.computeIsDefault) {
        let key = this.id_session_key
          ? "filtro_sessione_" + this.id_session_key
          : "";
        if (key) sessionStorage.setItem(key, valore);
      }
    },
  },

  mounted() {
    // NOTA: si da per scontato che al primo caricamento di InputFiltri, "Default" sia il set di filtri caricato per primo.
    this.applicaFiltriSessione();
  },

  computed: {
    computeApplicaFiltri() {
      // Copia i filtri da mandare e, qualora Array(), converte "valore" in stringa.
      let lista_filtri_dettaglio_copy = JSON.parse(
        JSON.stringify(this.lista_filtri_dettaglio)
      );

      lista_filtri_dettaglio_copy.forEach((e) => {
        if (e.tipo_oggetto == TipoOggetto.MULTI_SELECT)
          if (e.valore) e.valore = e.valore.toString();
      });

      return lista_filtri_dettaglio_copy;
    },

    computeIsDefault() {
      // Controlla se il set di filtri attualmente selezionato sia "Default".
      let item_set_filtro = this.lista_set_di_filtri.find((e) => {
        return e.id_ricerca === this.id_ricerca_sel;
      });
      if (item_set_filtro) return item_set_filtro.des_ricerca === "Default";
      else return false;
    },
  },

  watch: {
    lista_filtri: {
      handler() {
        // Aggiorna la lista di set filtri.
        if (this.lista_set_di_filtri.length == 0) {
          this.lista_set_di_filtri = [...this.lista_filtri];

          // Se nessun filtro è selezionato, prende quello default.
          if (!this.id_ricerca_sel && this.lista_set_di_filtri.length > 0)
            this.id_ricerca_sel = this.lista_set_di_filtri.find((e) => {
              return e.des_ricerca === "Default";
            }).id_ricerca;

          // NOTA: si da per scontato che al primo caricamento di InputFiltri, "Default" sia il set di filtri caricato per primo.
          this.aggiornaVisualizzazioneFiltri(true);
          this.convertiMultiSelectList();
        }

        for (let i = 0; i < this.lista_filtri_dettaglio.length; i++) {
          this.aggiornaDipendenze(this.lista_filtri_dettaglio[i]);
        }

        if (
          this.getSessione() &&
          this.lista_filtri[0] &&
          this.lista_filtri[0].query != null &&
          this.lista_filtri[0].query != "" &&
          this.ricerca_iniziale_eseguita == false
        ) {
          const sessione_tmp = JSON.parse(this.getSessione());
          if (
            sessione_tmp.filter(
              (s) => s.id_ricerca == this.lista_filtri[0].id_ricerca
            ).length > 0
          ) {
            this.ricercaDati();
            this.ricerca_iniziale_eseguita = true;
          }
        }
      },
      deep: true,
    },

    key_update: {
      handler() {
        this.lista_set_di_filtri = [...this.lista_filtri];

        // Se nessun filtro è selezionato, prende quello default.
        if (!this.id_ricerca_sel && this.lista_set_di_filtri.length > 0)
          this.id_ricerca_sel = this.lista_set_di_filtri.find((e) => {
            return e.des_ricerca === "Default";
          }).id_ricerca;

        this.aggiornaVisualizzazioneFiltri(this.computeIsDefault);
        this.convertiMultiSelectList();
      },
    },

    id_session_key: {
      handler() {
        // Se aggiornato il riferimento della sessione dei filtri, li ricarica e li manda al componente padre.
        // NOTA: si da per scontato che in InputFiltri, "Default" sia il set di filtri caricato per primo.
        this.applicaFiltriSessione();
      },
    },
  },
};
</script>

<style scoped>
.v-autocomplete,
.v-text-field {
  max-width: 250px;
}
</style>
